module.exports = __webpack_public_path__ + "img/customer8.ad863537.png";